<template>
    <div></div>
</template>

<script>
    import removePopup from './removePopup'
    export default {
        mixins: [removePopup],
        data() {
            return {
                checkbox: [],
                services: [],
                isCheckAll: false,
            }
        },
        methods: {
            saveServices(services) {
                this.services = services;
                let servicesSelectList = JSON.parse(localStorage.getItem('servicesSelectList'))
                if(servicesSelectList) {
                    // set selected flags from storage
                    this.checkbox = servicesSelectList;
                } else {
                    // set all flags
                    this.checkbox = this.selectedAllCheckboxes;
                }
                this.isCheckAll = this.updateCheckall;
            },
            servicesBoxStyle(color) {
                if(color) return { 'background-color': color }
                else return;
            },
            checkAll() {
                this.checkbox = [];
                if(this.isCheckAll) {
                    this.checkbox = this.selectedAllCheckboxes;
                }
                this.locationUpdate(this.checkbox)
            },
            checkboxChangeHandler(services) {
                this.locationUpdate(services);
                this.isCheckAll = this.updateCheckall;
            },
            locationUpdate(services) {
                if(this.drawCircleMode) {
                    this.removePopupsHandler();
                    this.$store.dispatch('REMOVE_DRAWING_CIRCLE');
                }
                localStorage.setItem('servicesSelectList', JSON.stringify(services));
                this.$store.dispatch('fetchLocations')
            },
        },
        computed: {
            updateCheckall() {
                let isSelected = this.checkbox.length === this.services.length;
                return isSelected
            },
            selectedAllCheckboxes() {
                let ids = this.services.map(layer => layer.id)
                return ids;
            },
            drawCircleMode() {
                return this.$store.getters.getDrawCircleMode
            }
        },
    }
</script>